import React from 'react';
import { TextField, Select, MenuItem, Box, Autocomplete, Tooltip } from '@mui/material';

import type { Expression, ArithmeticOperator } from './types';
import AddBoxIcon from '@mui/icons-material/AddBox';
import HeatPumpIcon from '@mui/icons-material/HeatPump';

interface Props {
  values: Expression[];
  onChange: (value: Expression[]) => void;
  attributeList: Array<any>;
}

const actionOperations: ArithmeticOperator[] = ['+', '-', '*', '/'];

export const PriceRuleActionValue: React.FC<Props> = ({ values, onChange, attributeList }) => {

  const handleAddCustom = () => {
    if (values.length > 0) {
      values[values.length - 1]['operator'] = '+';
      const updated = [
        ...values as Expression[],
        {
          value: 0
        }
      ];

      onChange(updated);

      return;
    }

    const updated = [
      {
        value: 0
      }
    ];

    onChange(updated);
  }

  const handleAdd = () => {
    if (values.length > 0) {
      values[values.length - 1]['operator'] = '+';
      const updated = [
        ...values as Expression[],
        {
          name: ''
        }
      ];

      onChange(updated);

      return;
    }

    const updated = [
      {
        name: ''
      }
    ];

    onChange(updated);
  }

  const isExpression = (attr: any): attr is Expression[] => Array.isArray(attr);

  return (
    <Box className="price-row-section-operation-attribute">
      {values.length > 0 ? (
        <>
          {values.map((expr, i) => (
            <React.Fragment key={i}>

              {expr.hasOwnProperty('value') && (
                <TextField
                  size="small"
                  type="number"
                  value={expr.value}
                  sx={{ width: 200 }}
                  onChange={(e) => {
                    const updated = [...values as Expression[]];
                    updated[i] = { ...updated[i], value: parseFloat(e.target.value) };
                    onChange(updated);
                  }}
                />
              )}

              {expr.hasOwnProperty('name') && (
                <Autocomplete
                  size="small"
                  disablePortal
                  options={attributeList}
                  value={attributeList.find(attr => attr.code === expr.name) || null}
                  isOptionEqualToValue={(option, val) => option.code === val.code}
                  getOptionLabel={(option) => option.name}
                  getOptionKey={(option) => option.code}
                  onChange={(e, val) => {
                    const updated = [...values as Expression[]];
                    updated[i] = { ...updated[i], name: val?.code || '' };
                    onChange(updated);
                  }}
                  sx={{ width: 200 }}
                  renderInput={(params) => <TextField {...params} />}
                />
              )}

              {expr.operator && (
                <Select
                  size="small"
                  value={expr.operator}
                  onChange={(e) => {
                    const updated = [...values as Expression[]];
                    updated[i] = { ...updated[i], operator: e.target.value as ArithmeticOperator };
                    onChange(updated);
                  }}
                >
                  {actionOperations.map((op) => (
                    <MenuItem key={op} value={op}>{op}</MenuItem>
                  ))}
                </Select>
              )}

              {i === values.length - 1 &&
                <Box className="price-row-section-attribute-button-container">
                  <Tooltip title="Custom">
                    <HeatPumpIcon fontSize="small" className="price-row-section-attribute-button"
                      onClick={handleAddCustom}
                    />
                  </Tooltip>
                  <Tooltip title="Attribute">
                    <AddBoxIcon fontSize="small" className="price-row-section-attribute-button"
                      onClick={handleAdd}
                    />
                  </Tooltip>
                </Box>
              }
            </React.Fragment>
          ))}
        </>
      ) : (
        <Box className="price-row-section-attribute-button-container">
          <Tooltip title="Custom">
            <HeatPumpIcon fontSize="small" className="price-row-section-attribute-button"
              onClick={handleAddCustom}
            />
          </Tooltip>
          <Tooltip title="Attribute">
            <AddBoxIcon fontSize="small" className="price-row-section-attribute-button"
              onClick={handleAdd}
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  );
}
